// Common car brands and models used in Danish GoMore fleets.
// Used for HTML5 <datalist> auto-complete in Cars dialog.
// User types "sk" -> sees "Skoda" suggestion, etc.
// User can still type any free-form value (datalist is non-restrictive).

export const CAR_BRANDS = [
  "Hyundai",
  "Kia",
  "Toyota",
  "Ford",
  "Chevrolet",
  "Citroën",
  "Peugeot",
  "Volkswagen",
  "Skoda",
  "Seat",
  "Audi",
  "BMW",
  "Mercedes-Benz",
  "Renault",
  "Opel",
  "Fiat",
  "Nissan",
  "Mazda",
  "Volvo",
  "Tesla",
  "Honda",
  "Suzuki",
  "Mitsubishi",
  "Dacia",
  "Alfa Romeo",
  "Mini",
  "Mercedes",
  "Lexus",
  "Jeep",
  "Porsche",
  "Land Rover",
];

export const CAR_MODELS = [
  // Hyundai
  "i10", "i20", "i30", "Tucson", "Kona", "Bayon", "Ioniq", "Ioniq 5",
  // Kia
  "Picanto", "Picanto Attraction", "Rio", "Ceed", "Stonic", "Sportage", "Niro",
  // Toyota
  "Aygo", "Aygo X", "Yaris", "Yaris Cross", "Corolla", "C-HR", "RAV4", "Auris",
  // Ford
  "Ka+", "Fiesta", "Focus", "Puma", "Kuga", "Mondeo", "Galaxy",
  // Chevrolet
  "Spark", "Aveo", "Cruze", "Captiva",
  // Citroën
  "C1", "C3", "C4", "C4 Cactus", "C5",
  // Peugeot
  "108", "208", "2008", "308", "3008",
  // Volkswagen
  "Up", "Polo", "Golf", "T-Roc", "Tiguan", "Passat", "ID.3", "ID.4",
  // Skoda
  "Citigo", "Fabia", "Fabia Combi", "Scala", "Octavia", "Kamiq", "Karoq",
  // Seat
  "Mii", "Ibiza", "Leon", "Arona", "Ateca",
  // Renault
  "Twingo", "Clio", "Captur", "Megane", "Zoe",
  // Opel
  "Karl", "Corsa", "Astra", "Mokka", "Crossland",
  // Fiat
  "500", "Panda", "Tipo", "500X",
  // Nissan
  "Micra", "Note", "Juke", "Qashqai", "Leaf",
  // Mazda
  "2", "3", "CX-3", "CX-30", "CX-5",
  // Volvo
  "V40", "V60", "V90", "XC40", "XC60", "XC90", "EX30",
  // Tesla
  "Model 3", "Model Y", "Model S", "Model X",
  // Audi
  "A1", "A3", "A4", "Q2", "Q3", "Q4 e-tron",
  // BMW
  "1-serie", "2-serie", "3-serie", "X1", "X2", "i3",
  // Mini
  "Cooper", "Countryman",
  // Suzuki
  "Swift", "Ignis", "Vitara", "S-Cross",
  // Honda
  "Jazz", "Civic", "HR-V", "CR-V",
  // Dacia
  "Sandero", "Logan", "Duster", "Spring",
  // Mitsubishi
  "Space Star", "ASX", "Outlander",
];
